import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { ICON_DATA, ICON_TOKEN } from './constants';
import { IconService } from './services/icon.service';
import { Icon } from './types/icon.type';

@NgModule()
export class PortalSharedIconModule {
  constructor(@Optional() @SkipSelf() parentModule: PortalSharedIconModule, readonly svgIconService: IconService) {
    if (parentModule) {
      throw new Error('PortalSharedIconModule is already loaded. Import it in the AppModule only!');
    }
  }

  static forRoot(icons: Icon[] = []): ModuleWithProviders<PortalSharedIconModule> {
    return {
      ngModule: PortalSharedIconModule,
      providers: [{ provide: ICON_TOKEN, useValue: [...ICON_DATA, ...icons] }, IconService],
    };
  }
}
